import { goodBitsClient } from "./httpService";

export function fetchCurrencies(userLanguage) {
  return goodBitsClient().get("/masterdata/v1/currencies", {
    params: {
      userLanguage,
    },
  });
}

export async function fetchRatePlans(userLanguage, ratePlanCodes) {
  return await goodBitsClient().get("/masterdata/v2/rate-plans", {
    params: {
      userLanguage,
      ratePlanCodes,
    },
  });
}

export async function fetchRatePlanCategories(userLanguage) {
  return goodBitsClient().get("/masterdata/v2/rate-plan-categories", {
    params: {
      userLanguage,
    },
  });
}

export function fetchRatePlanPolicies(userLanguage) {
  return goodBitsClient().get("/masterdata/v2/rate-plan-policies", {
    params: {
      userLanguage,
    },
  });
}

export function fetchAddons(hotelIdOrCode, userLanguage, expands) {
  return fetchPropertyData(hotelIdOrCode, userLanguage, expands);
}

export async function fetchPropertyData(hotelIdOrCode, userLanguage, expands) {
  let expandSeries = expands.join(",");
  return await goodBitsClient().get(
    `/masterdata/v2/hotels/${hotelIdOrCode}?userLanguage=${userLanguage}&expand=${expandSeries}`,
  );
}

export async function fetchMultiplePropertyData(
  hotelCodes,
  userLanguage,
  expands,
) {
  const hotels = [];

  // Can NOT be this call since it does not deliver mediaAssets
  // return await goodBitsClient().get(`/masterdata/v2/hotels?userLanguage=${userLanguage}&hotelCodes=${hotelCodes.join()}`);

  async function fetchPropertyMasterData(hotelCode) {
    const propertyData = await fetchPropertyData(
      hotelCode,
      userLanguage,
      expands,
    );
    const hotelData = await propertyData;
    hotels[hotelCode] = {
      name: hotelData.data.name,
      img: hotelData.data.mainImage.file,
      media:
        [
          hotelData.data.mainImage.file,
          ...hotelData.data.mediaAssets.map((media) => media.file),
        ] || [],
      address: hotelData.data.location.googleMapsAddressQuery,
      checkInOut: hotelData.data.checkInCheckOutConfiguration,
      timeZone: hotelData.data.city?.timeZone?.identifier || null,
    };
    return hotelData;
  }
  async function loadMultipleProperties(hotelCodes) {
    const promises = hotelCodes.map(fetchPropertyMasterData);
    const responses = await Promise.all(promises);
    return responses;
  }

  await loadMultipleProperties(hotelCodes);

  return hotels;
}

export function fetchCountries(userLanguage, onlyWithHotels = true) {
  return goodBitsClient().get("/masterdata/v2/countries", {
    params: {
      userLanguage,
      onlyWithHotel: onlyWithHotels,
    },
  });
}

export function fetchLanguages(userLanguage) {
  return goodBitsClient().get("/masterdata/v3/configuration/languages", {
    params: {
      contentLanguage: userLanguage,
    },
  });
}

export async function fetchAllHotels(userLanguage) {
  return await goodBitsClient().get("/masterdata/v2/hotels", {
    params: {
      userLanguage,
    },
  });
}

export async function fetchHotel(hotelIdOrCode, userLanguage) {
  return await goodBitsClient().get(`/masterdata/v2/hotels/${hotelIdOrCode}`, {
    params: {
      userLanguage,
    },
  });
}

export async function fetchHotelsFromCity(cityId, userLanguage) {
  return await goodBitsClient().get(`/masterdata/v2/hotels/`, {
    params: {
      userLanguage,
      cityId,
    },
  });
}

export async function fetchFAQs(hotelIdOrCode, userLanguage) {
  return await goodBitsClient().get(
    `/masterdata/v2/hotels/${hotelIdOrCode}/faq`,
    {
      params: {
        userLanguage,
      },
    },
  );
}

export async function fetchHotelMeetingRooms(userLanguage, hotelCode) {
  return await goodBitsClient().get(`/masterdata/v3/properties/${hotelCode}`, {
    params: {
      contentLanguage: userLanguage,
      expand: "meetingSpace",
    },
  });
}
export async function getMasterdataV3(
  endpoint,
  userLanguage,
  expandParams = undefined,
  propertyCode = undefined,
) {
  const expand = expandParams ? `?&expand=${expandParams.join(",")}` : "";
  const url = `/masterdata/v3/${endpoint}${propertyCode ? `/${propertyCode}` : ""}${expand}`;
  return await goodBitsClient().get(url, {
    params: {
      contentLanguage: userLanguage,
    },
  });
}

/**
 * expand: Parameter to expand on certain topics, comma separated. Unknown expand parameters are quietly ignored.
   Available values : hotel, meetingSpace, coworking, bars, pools, art, genericFacilities, location
 * 
 */
export async function getContentForProperty(
  propertyCode,
  locale,
  expand = [
    "hotel",
    "meetingSpace",
    "coworking",
    "bars",
    "pools",
    "art",
    "genericFacilities",
    "location",
  ],
) {
  const property = await getMasterdataV3(
    "properties",
    localeToCfLocal(locale),
    expand,
    propertyCode,
  )
    .then((res) => res.data)
    .catch(() => null);

  return property;
}

export async function getContentForFeature(propertyCode, locale) {
  return await getMasterdataV3(
    "properties",
    locale,
    ["bars", "location"],
    propertyCode,
  )
    .then((res) => res.data)
    .catch(() => null);
}
